import { Tooltip } from "@material-ui/core";
import InfoOutlined from "@material-ui/icons/InfoOutlined";
import React, { useEffect } from "react";
import { Row, Col } from "react-grid-system";

import { useFormikContext } from "formik";
import { makeGetTeammates,  } from "../../../../../selectors/employer/teammateSelectors";
import { ACTIVE } from "../../../../shared/Team/constants";
import { useSelector } from "react-redux";
import { stateOptions } from "../../../../../util/constantsToOptions";
import FormContextDatePicker from "../../../../forms/formik/FormContextInputs/FormContextDatePicker";
import FormContextDropdown from "../../../../forms/formik/FormContextInputs/FormContextDropdown";
import FormContextTextField from "../../../../forms/formik/FormContextInputs/FormContextTextField";
import FormContextWysiwyg from "../../../JobCasts/create/formContextInputs/FormContextWysiwyg";
import SectionHeader from "../../../JobCasts/view/Candidates/actions/modals/Hire/SectionHeader";

import EmployerTempPrerequisitesField from "./EmployerTempPrerequisitiesField";
import FieldSection from "./FieldSection";
import { getCurrentOrganization } from "../../../../../selectors/organizationSelectors";
import FormContextDropdownSelect from "../../../JobCasts/create/formContextInputs/FormContextDropdownSelect";

function StartDateField() {
  return (
    <FormContextDatePicker id="scheduledStartDate" label="Start Date" />
  );
}

function EndDateField() {
  return (
    <FormContextDatePicker
      id="scheduledEndDate"
      label={(
        <Tooltip
          placement="right"
          title="You will be reminded when this date approaches"
        >
          <div className="static-input-label">
            Tentative End Date
            <InfoOutlined
              style={{
                color: "#B0BEC5",
                fontSize: 13,
                paddingLeft: 4,
              }}
            />
          </div>
        </Tooltip>
      )}
    />
  );
}

function StateField() {
  return (
    <FormContextDropdown
      id="primaryWorkState"
      label="Primary Work State"
      options={stateOptions}
    />
  );
}

function ZipCodeField() {
  return (
    <FormContextTextField
      id="primaryWorkZipCode"
      label="Primary Work Zip"
      inputProps={{ maxLength: 5 }}
    />
  );
}

function TimesheetSubmissionPartyField() {
  return (
    <FormContextDropdown
      id="timesheetSubmissionParty"
      label={(
        <Tooltip
          placement="right"
          title="This is the party that will be responsible for submitting timesheets. Please contact RecruitiFisupport if this is incorrect."
        >
          <div>
            Timesheet Submission Party
            <InfoOutlined
              style={{
                color: "#B0BEC5",
                fontSize: 13,
                paddingLeft: 4,
              }}
            />
          </div>
        </Tooltip>
      )}
      disabled={true}
      options={[{ label: "My Company", value: "client" }, { label: "Staffing Firm", value: "supplier" }]}
    />
  );
}

function StatementOfWorkField() {
  return (
    <FormContextWysiwyg
      id="statementOfWorkDescription"
      label={(
        <Tooltip
          placement="right"
          title="This will populate as part of the Statement of Services to be signed before work can begin."
        >
          <div>
            Description of Work
            <InfoOutlined
              style={{
                color: "#B0BEC5",
                fontSize: 13,
                paddingLeft: 4,
              }}
            />
          </div>
        </Tooltip>
      )}
      maxLength={10000}
    />
  );
}

function SignerDuplicateGuard() {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (
      values.hrpbSignerIndividualId &&
      values.sosSignerIndividualId &&
      values.hrpbSignerIndividualId === values.sosSignerIndividualId
    ) {
      setFieldValue("hrpbSignerIndividualId", "");
    }
  }, [values.sosSignerIndividualId, values.hrpbSignerIndividualId, setFieldValue]);

  return null;
}

function StatementOfServicesSignerField() {
  const teammates = useSelector(makeGetTeammates(ACTIVE, false));
  const organization = useSelector(getCurrentOrganization);
  const { values } = useFormikContext();

  const options = teammates
    .filter((teammate) => teammate.id !== values.hrpbSignerIndividualId)
    .map((teammate) => ({
      value: teammate.id,
      label: teammate.attributes.name,
    }));

  return (
    <div style={{ marginTop: 16 }}>
      <FormContextDropdownSelect
        id="sosSignerIndividualId"
        label="Statement of Services Signatory"
        options={options}
        isMulti={false}
        isClearable={false}
      />
      {
        organization.requiredSosSignerName && (
          <FormContextTextField
            id="sosSignerName"
            label="Additional Signer"
            value={organization.requiredSosSignerName}
            disabled={true}
          />
        )
      }
    </div>
  );
}

function HrpbSignerField() {
  const teammates = useSelector(makeGetTeammates(ACTIVE, false));
  const organization = useSelector(getCurrentOrganization);
  const { values } = useFormikContext();

  if (!organization.hrpbSignerRequired) {
    return null;
  }

  const options = teammates
    .filter((teammate) => teammate.id !== values.sosSignerIndividualId)
    .map((teammate) => ({
      value: teammate.id,
      label: teammate.attributes.name,
    }));

  return (
    <div style={{ marginTop: 16 }}>
      <FormContextDropdownSelect
        id="hrpbSignerIndividualId"
        // this is correct name
        label="HRBP Signatory"
        options={options}
        isMulti={false}
        isClearable={false}
      />
    </div>
  );
}

function WorkInformation() {
  return (
    <>
      <SectionHeader title="Work Information" />
      <FieldSection>
        <Row>
          <Col xs={12} md={4}>
            <StartDateField />
          </Col>
          <Col xs={12} md={4}>
            <EndDateField />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4}>
            <StateField />
          </Col>
          <Col xs={12} md={4}>
            <ZipCodeField />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4}>
            <TimesheetSubmissionPartyField />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <StatementOfWorkField />
          </Col>
        </Row>
      </FieldSection>
      <SectionHeader title="Pre-Assignment Steps" />
      <FieldSection>
        <Row>
          <EmployerTempPrerequisitesField />
        </Row>
        <SignerDuplicateGuard />
        <Row>
          <Col xs={6}>
            <StatementOfServicesSignerField />
          </Col>
          <Col xs={6}>
            <HrpbSignerField />
          </Col>
        </Row>
      </FieldSection>
    </>
  );
}

export default WorkInformation;
